import toggleBodyScroll from './toggleBodyScroll';

export const initNewsletterSignup = () => {
  const newsLetterSignupFormSubmitButton = document.getElementById('mc-embedded-subscribe');
  const newsLetterBlogSignupFormSubmitButton = document.getElementById('mc-embedded-subscribe-blog');

  const newsletterSignupElements = [newsLetterSignupFormSubmitButton, newsLetterBlogSignupFormSubmitButton];

  for (let i = 0; i < newsletterSignupElements.length; i++) {
    if (newsletterSignupElements[i] !== null) {
      newsletterSignupElements[i].addEventListener('click', (e) => {
        e.preventDefault();
        console.log('in on click');
        console.log(e);
        const rad_name = 'KIDS';
        const Email = document.getElementById('mce-EMAIL');
        const FirstName = document.getElementById('mce-FNAME');
        const LastName = document.getElementById('mce-LNAME');

        const WinterNewsletter = document.getElementById('mce-group[3661]-3661-0');
        const SummerNewsletter = document.getElementById('mce-group[3661]-3661-1');


        const formData = new FormData();

        formData.append('Email', Email.value);
        formData.append('FirstName', FirstName.value);
        formData.append('LastName', LastName.value);
        formData.append('SummerNewsletter', SummerNewsletter.checked);
        formData.append('WinterNewsletter', WinterNewsletter.checked);


        if (newsLetterSignupFormSubmitButton && newsLetterSignupFormSubmitButton.id == 'mc-embedded-subscribe') {

          const rad_val = document.querySelector('input[name=' + rad_name + ']:checked');
          const ChildrenInParty = rad_val === 'Yes';
          const ContactByEmail = document.getElementById('mce-group[4523]-4523-0');
          const ContactByPost = document.getElementById('mce-group[4523]-4523-1');
          const ContactByTargetedOnlineAdvertising = document.getElementById('mce-group[4523]-4523-2');
          const ContactByTelephone = document.getElementById('mce-group[4523]-4523-3');
          const ContactByText = document.getElementById('mce-group[4523]-4523-4');

          const PreferrSkiingDuringSchoolHolidays = document.getElementById('mce-group[4511]-4511-0');
          const PreferrSkiingOutsideOfSchoolHolidays = document.getElementById('mce-group[4511]-4511-1');
          const PreferrSkiingLateSeason = document.getElementById('mce-group[4511]-4511-2');

          const PreferrSkiingChristmas = document.getElementById('mce-group[4511]-4511-3');
          const SkiOftenAsPossible = document.getElementById('mce-group[4511]-4511-4');

          formData.append('ChildrenInParty', ChildrenInParty.value);
          formData.append('ContactByEmail', ContactByEmail.checked);
          formData.append('ContactByPost', ContactByPost.checked);
          formData.append('ContactByTargetedOnlineAdvertising', ContactByTargetedOnlineAdvertising.checked);
          formData.append('ContactByTelephone', ContactByTelephone.checked);
          formData.append('ContactByText', ContactByText.checked);
          formData.append('PreferrSkiingChristmas', PreferrSkiingChristmas.checked);
          formData.append('PreferrSkiingDuringSchoolHolidays', PreferrSkiingDuringSchoolHolidays.checked);
          formData.append('PreferrSkiingLateSeason', PreferrSkiingLateSeason.checked);
          formData.append('PreferrSkiingOutsideOfSchoolHolidays', PreferrSkiingOutsideOfSchoolHolidays.checked);
          formData.append('SkiOftenAsPossible', SkiOftenAsPossible.checked);

        } else {

          formData.append('ChildrenInParty', false);
          formData.append('ContactByEmail', false);
          formData.append('ContactByPost', false);
          formData.append('ContactByTargetedOnlineAdvertising', false);
          formData.append('ContactByTelephone', false);
          formData.append('ContactByText', false);
          formData.append('PreferrSkiingChristmas', false);
          formData.append('PreferrSkiingDuringSchoolHolidays', false);
          formData.append('PreferrSkiingLateSeason', false);
          formData.append('PreferrSkiingOutsideOfSchoolHolidays', false);
          formData.append('SkiOftenAsPossible', false);
        }


        fetch('/umbraco/surface/HiveSurface/SignUp', {
          method: 'POST',
          body: formData
        })
          .then(response => response.json())
          .then(result => {

            window.location.href = result.redirectUrl;
          })
          .catch(error => {
            console.error('Error:', error);
          });
        const bloSignUpForm = document.getElementById('mc-embedded-subscribe-form-blog');
        if (bloSignUpForm) {
          bloSignUpForm.submit();
        }
        const signUpForm = document.getElementById('mc-embedded-subscribe-form');
        if (signUpForm) {
          signUpForm.submit();
        }
      });
    }
  }

  const newsletterSignupModal = document.getElementsByClassName('newsletter-signup__modal');
  let newsletterSignupOverlay = null;

  if (newsletterSignupModal !== undefined && newsletterSignupModal.length > 0) {
    newsletterSignupOverlay = newsletterSignupModal[0].getElementsByClassName('modal__overlay')[0];
  }
  if (newsletterSignupOverlay === null) {
    return;
  }
  const showNewsletterOnLeaveIntent = document.getElementById('show-newsletter-on-leave-intent');
  let shownPopup = false;

  const newsletterSignupButton = document.getElementsByClassName('newsletter-signup-button');
  const submitButton = document.getElementById('mc-embedded-subscribe');
  const closeButton = newsletterSignupOverlay.getElementsByClassName('modal__overlay__close-button')[0];
  const requiredFields = document.getElementsByClassName('required');
  const validateFieldsArray = new Array(requiredFields.length);

  /*window.history.pushState('newsletterclosed', null, null);*/

  validateFieldsArray.fill(false);
  //submitButton.disabled = true;

  if (!newsletterSignupOverlay) {
    return;
  }

  if (newsletterSignupButton.length === 0) {
    return;
  }

  Array.from(newsletterSignupButton).forEach(button => {
    button.addEventListener('click', () => {
      displayNewsletterOverlay(newsletterSignupOverlay);
    });
    return true;
  });

  closeButton.addEventListener('click', () => {
    closeNewsletterOverlay(newsletterSignupOverlay);
  });

  /*var hideModal = function(event) {
      if (event.state == 'newsletterclosed') {
          closeNewsletterOverlay();
      }
  };

  window.addEventListener('popstate', hideModal);*/

  let i = 0;
  for (const field of requiredFields) {
    field.addEventListener('change', generateCheckRequiredFields(i++, validateFieldsArray, submitButton));
  }


  if (showNewsletterOnLeaveIntent) {
    if (showNewsletterOnLeaveIntent.getAttribute('data-show') && !shownPopup) {
      let currentlyLeaving = false;
      document.body.addEventListener('mouseleave', e => {
        if (shownPopup) {
          return;
        }

        if (e.clientY > 0 || currentlyLeaving) {
          return;
        }
        currentlyLeaving = true;
        const surveyTimeout = setTimeout(() => displayNewsletterOverlay(newsletterSignupOverlay), 250);
        shownPopup = true;
        document.body.addEventListener('mouseenter', e => {
          clearTimeout(surveyTimeout);
          currentlyLeaving = false;
        });
      });
    }
  }
};

const displayNewsletterOverlay = (newsletterSignupOverlay) => {
  toggleBodyScroll(() => closeNewsletterOverlay(newsletterSignupOverlay));
  newsletterSignupOverlay.classList.add('--visible');
  //window.history.pushState('newsletteropened', null, null);
};

export const closeNewsletterOverlay = (newsletterSignupOverlay) => {
  toggleBodyScroll();
  newsletterSignupOverlay.classList.remove('--visible');
  //window.history.pushState('newsletterclosed', null, null);
};

const generateCheckRequiredFields = (fieldNumber, _validationArray, _submitButton) => {
  const validationArray = _validationArray;
  const submitButton = _submitButton;

  return function (e) {
    validationArray[fieldNumber] = e.target.value.length > 0;

    if (validationArray.every(x => x)) {
      submitButton.disabled = false;
    }
  };
};
